import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { BackButton } from '@facet-wealth/design';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const BackButtonPicker = () => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return pickWithPriority(pageContentResource, [
    [fr.relationships.previousLink.name, (
      <BackButton
        label="Go Back"
        onClick={() => {
          logStandardizedEvent(categories.clientWhatIf, eventTypes.clickButton, 'Clicked Back button');
          loadPageContentLink(pageContentResource
            .relationship(fr.relationships.previousLink.name)
            .link('related'));
        }}
        test={'back-button'}
      />
    )],
  ], null);
};

export default BackButtonPicker;
